import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Typography, FormControl, InputLabel, Select, MenuItem, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Button, TextField, Alert, Snackbar, CircularProgress,
  Tabs, Tab, Checkbox, FormControlLabel, Stack, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { useAuth } from '../components/AuthContext';
import { API_BASE_URL } from '../components/api.js';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function PontoEscala() {
  const [tabIndex, setTabIndex] = useState(0);

  // --- ESTADOS DE DADOS ---
  const [funcionarios, setFuncionarios] = useState([]);
  const [jornadas, setJornadas] = useState([]);
  const [escalas, setEscalas] = useState([]);

  // --- ESTADOS ABA 0: VINCULAR ---
  const [selectedFunc, setSelectedFunc] = useState('');
  const [selectedJornadaFiltro, setSelectedJornadaFiltro] = useState('');
  const [selectedEscalaFunc, setSelectedEscalaFunc] = useState('');
  const [dataInicio, setDataInicio] = useState(new Date().toISOString().split('T')[0]);

  // --- ESTADOS DE INTERAÇÃO (POPUP E AVISOS) ---
  const [openConfirm, setOpenConfirm] = useState(false);
  const [msgConfirm, setMsgConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // --- ESTADOS ABA 1 E 2 (CRIAÇÃO/EDIÇÃO) ---
  const [selectedJornadaNew, setSelectedJornadaNew] = useState('');
  const [newEscalaData, setNewEscalaData] = useState({});
  const [allEqualNew, setAllEqualNew] = useState(false);
  const [selectedJornadaEdit, setSelectedJornadaEdit] = useState('');
  const [selectedEscalaEdit, setSelectedEscalaEdit] = useState('');
  const [editEscalaData, setEditEscalaData] = useState(null);
  const [allEqualEdit, setAllEqualEdit] = useState(false);

  const { authenticatedFetch } = useAuth();

  const [openConfirmDataAntiga, setOpenConfirmDataAntiga] = useState(false);
  const [dataPendente, setDataPendente] = useState(null);
  const [mesLimiteExibicao, setMesLimiteExibicao] = useState('');

    const [dataEscalaAntigaExibicao, setDataEscalaAntigaExibicao] = useState('');


  const daysOfWeek = [
    { label: 'Segunda-feira', entrada: 'entrada_segunda', saida: 'saida_segunda' },
    { label: 'Terça-feira', entrada: 'entrada_terca', saida: 'saida_terca' },
    { label: 'Quarta-feira', entrada: 'entrada_quarta', saida: 'saida_quarta' },
    { label: 'Quinta-feira', entrada: 'entrada_quinta', saida: 'saida_quinta' },
    { label: 'Sexta-feira', entrada: 'entrada_sexta', saida: 'saida_sexta' },
    { label: 'Sábado', entrada: 'entrada_sabado', saida: 'saida_sabado' },
    { label: 'Domingo', entrada: 'entrada_domingo', saida: 'saida_domingo' },
  ];

  const handleDataInicioChange = (novaData) => {
    if (!novaData) { setDataInicio(novaData); return; }

    const [y, m] = novaData.split('-').map(Number);
    const anoMesSelecionado = new Date(y, m - 1, 1);

    const hoje = new Date();
    const limiteAnoMes = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);

    if (anoMesSelecionado < limiteAnoMes) {
      setMesLimiteExibicao(limiteAnoMes.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }));
      setDataPendente(novaData);
      setOpenConfirmDataAntiga(true);
    } else {
      setDataInicio(novaData);
    }
  };

  const loadInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const [resJ, resE, resF] = await Promise.all([
        authenticatedFetch(`${API_BASE_URL}/api/ponto-funcionarios-editar-jornadas/`),
        authenticatedFetch(`${API_BASE_URL}/api/ponto-funcionarios-editar-escalas/`),
        authenticatedFetch(`${API_BASE_URL}/api/ponto-escala-funcionarios-preencher/`)
      ]);

      if (resJ.ok) setJornadas(await resJ.json());
      if (resE.ok) setEscalas(await resE.json());
      if (resF.ok) {
        const dataF = await resF.json();
        setFuncionarios(Array.isArray(dataF) ? dataF : (dataF.ativos || []));
      }
    } catch (error) {
      console.error("Erro no fetch:", error);
    } finally {
      setLoading(false);
    }
  }, [authenticatedFetch]);

  useEffect(() => {
    loadInitialData();
  }, [loadInitialData]);

  // 2. Seleção Automática CORRIGIDA PARA ESCALA 0
  useEffect(() => {
    if (selectedFunc) {
      const func = funcionarios.find(f => Number(f.id) === Number(selectedFunc));
      
      if (func && (func.escala !== null && func.escala !== undefined)) {
        const escalaEncontrada = escalas.find(e => Number(e.id) === Number(func.escala));
        if (escalaEncontrada) {
            setSelectedJornadaFiltro(escalaEncontrada.jornada);
        }
        setSelectedEscalaFunc(func.escala);

        if (func.data_escala) {
          const dOld = new Date(func.data_escala.split('T')[0] + 'T00:00:00');
          setDataEscalaAntigaExibicao(dOld.toLocaleDateString('pt-BR'));
        } else {
          setDataEscalaAntigaExibicao('');
        }
      } else {
        setSelectedEscalaFunc('');
        setSelectedJornadaFiltro('');
        setDataEscalaAntigaExibicao('');
      }

      // Sempre reseta para hoje ao trocar de funcionário — nunca herda a data antiga
      setDataInicio(new Date().toISOString().split('T')[0]);
    }
  }, [selectedFunc, funcionarios, escalas]);

  // --- LOGICA DE SALVAMENTO COM POPUP (RESTAURADA) ---
  const [impactoAtual, setImpactoAtual] = useState(null);

  const mesesNomes = {
    '01': 'janeiro', '02': 'fevereiro', '03': 'março', '04': 'abril',
    '05': 'maio', '06': 'junho', '07': 'julho', '08': 'agosto',
    '09': 'setembro', '10': 'outubro', '11': 'novembro', '12': 'dezembro'
  };

  const formatarMesAno = (mesStr) => {
    const [ano, mes] = mesStr.split('-');
    return `${mesesNomes[mes]}/${ano}`;
  };

  const handlePreSave = async () => {
    if (!selectedFunc || (selectedEscalaFunc === '' || selectedEscalaFunc === null)) {
      setSnackbar({ open: true, message: 'Selecione funcionário e escala!', severity: 'warning' });
      return;
    }

    let impacto;
    try {
      const res = await authenticatedFetch(
        `${API_BASE_URL}/api/ponto-escala-calcular-impacto/?funcionario_id=${selectedFunc}&data_inicio=${dataInicio}`
      );
      impacto = await res.json();
      setImpactoAtual(impacto);
    } catch (e) {
      setSnackbar({ open: true, message: 'Erro ao calcular impacto.', severity: 'error' });
      return;
    }

    const func = funcionarios.find(f => Number(f.id) === Number(selectedFunc));
    const dNew = new Date(dataInicio.replace(/-/g, '\/'));
    const dOntem = new Date(dNew);
    dOntem.setDate(dOntem.getDate() - 1);
    const diaAnteriorExibicao = dOntem.toLocaleDateString('pt-BR');

    let mensagem = `Deseja aplicar a nova escala a partir de ${dNew.toLocaleDateString('pt-BR')}?`;

    if (impacto.mudou_turno) {
      if (impacto.total_dias > 0) {
        const linhas = impacto.meses.map(m => `Afeta ${m.dias} dia(s) em ${formatarMesAno(m.mes)}`).join('\n');
        mensagem =
          `ATENÇÃO — mudança de turno vai apagar e refazer:\n\n${linhas}\n\n` +
          `Total: ${impacto.total_dias} dia(s) de ponto serão apagados e recriados.\n\n` +
          `Além disso, deseja excluir lançamentos do dia anterior (${diaAnteriorExibicao})?`;
      } else {
        mensagem = `Mudança de turno detectada, sem registros existentes a apagar. Deseja excluir os lançamentos do dia anterior (${diaAnteriorExibicao})?`;
      }
    }

    setMsgConfirm(mensagem);
    setOpenConfirm(true);
  };

  const executeSave = async (excluirAnterior) => {
    setOpenConfirm(false);
    setLoading(true);
    try {
      const res = await authenticatedFetch(`${API_BASE_URL}/api/ponto-escala-salvar-escala/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          funcionario_id: selectedFunc,
          escala_id: selectedEscalaFunc,
          data_inicio: dataInicio,
          excluir_dia_anterior: excluirAnterior,
          confirmou_impacto: true
        }),
      });

      if (res.ok) {
        setSnackbar({ open: true, message: 'Escala e Ponto processados!', severity: 'success' });
        loadInitialData();
      } else {
        const err = await res.json();
        setSnackbar({ open: true, message: err.error || 'Erro no processamento.', severity: 'error' });
      }
    } catch (e) {
      setSnackbar({ open: true, message: 'Erro de conexão.', severity: 'error' });
    } finally {
      setLoading(false);
      setImpactoAtual(null);
    }
  };

  // --- HANDLERS AUXILIARES ---
  const handleNewCellChange = (dayLabel, field, value) => {
      setNewEscalaData(prev => {
          const updated = { ...prev, [field]: value };

          // Se checkbox ativo E alterou campo da segunda → copia para todos
          if (allEqualNew && dayLabel === 'Segunda-feira') {
              const novaEntrada = field === 'entrada_segunda' ? value : updated['entrada_segunda'];
              const novaSaida   = field === 'saida_segunda'   ? value : updated['saida_segunda'];
              daysOfWeek.forEach(d => {
                  updated[d.entrada] = novaEntrada;
                  updated[d.saida]   = novaSaida;
              });
          }

          return updated;
      });
  };

  useEffect(() => {
    const escala = escalas.find(e => Number(e.id) === Number(selectedEscalaEdit));
    setEditEscalaData(escala ? { ...escala } : null);
  }, [selectedEscalaEdit, escalas]);

  const handleEditCellChange = (dayLabel, field, value) => {
      setEditEscalaData(prev => {
          const updated = { ...prev, [field]: value };

          if (allEqualEdit && dayLabel === 'Segunda-feira') {
              const novaEntrada = field === 'entrada_segunda' ? value : updated['entrada_segunda'];
              const novaSaida   = field === 'saida_segunda'   ? value : updated['saida_segunda'];
              daysOfWeek.forEach(d => {
                  updated[d.entrada] = novaEntrada;
                  updated[d.saida]   = novaSaida;
              });
          }

          return updated;
      });
  };

  useEffect(() => {
      if (allEqualNew && newEscalaData['entrada_segunda']) {
          setNewEscalaData(prev => {
              const updated = { ...prev };
              daysOfWeek.forEach(d => {
                  updated[d.entrada] = prev['entrada_segunda'];
                  updated[d.saida]   = prev['saida_segunda'];
              });
              return updated;
          });
      }
  }, [allEqualNew]);

  useEffect(() => {
      if (allEqualEdit && editEscalaData?.['entrada_segunda']) {
          setEditEscalaData(prev => {
              const updated = { ...prev };
              daysOfWeek.forEach(d => {
                  updated[d.entrada] = prev['entrada_segunda'];
                  updated[d.saida]   = prev['saida_segunda'];
              });
              return updated;
          });
      }
  }, [allEqualEdit]);

  const handleUpdateEscala = async () => {
    try {
      const res = await authenticatedFetch(`${API_BASE_URL}/api/ponto-escalas-editar/${editEscalaData.id}/`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editEscalaData),
      });
      if (res.ok) { setSnackbar({ open: true, message: 'Escala atualizada!', severity: 'success' }); loadInitialData(); }
    } catch (e) { console.error(e); }
  };

  const handleSaveNewEscala = async () => {
    try {
      const res = await authenticatedFetch(`${API_BASE_URL}/api/ponto-escalas/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...newEscalaData, jornada: selectedJornadaNew }),
      });
      if (res.ok) {
        setSnackbar({ open: true, message: 'Escala criada!', severity: 'success' });
        loadInitialData();
        setNewEscalaData({});
        setSelectedJornadaNew('');
      }
    } catch (e) { console.error(e); }
  };

  if (loading && funcionarios.length === 0) return <CircularProgress sx={{ m: 5 }} />;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>Gestão de Escalas e Turnos</Typography>
      
      <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)} sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Vincular Funcionário" />
        <Tab label="Nova Escala" />
        <Tab label="Editar Escalas" />
      </Tabs>

      {/* ABA 0: VINCULAR */}
      <TabPanel value={tabIndex} index={0}>
        <Stack direction="row" spacing={2} sx={{ mb: 4, flexWrap: 'wrap' }}>
          <FormControl sx={{ minWidth: 280 }}>
            <InputLabel>FUNCIONÁRIO</InputLabel>
            <Select value={selectedFunc} label="FUNCIONÁRIO" onChange={e => setSelectedFunc(e.target.value)}>
              <MenuItem value=""><em>Selecione...</em></MenuItem>
              {funcionarios.map(f => <MenuItem key={f.id} value={f.id}>{f.nome}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 220 }}>
            <InputLabel>JORNADA</InputLabel>
            <Select value={selectedJornadaFiltro} label="JORNADA" onChange={e => { setSelectedJornadaFiltro(e.target.value); setSelectedEscalaFunc(''); }}>
              <MenuItem value=""><em>Todas</em></MenuItem>
              {jornadas.map(j => <MenuItem key={j.id} value={j.id}>{j.nome}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 150 }}>
            <InputLabel>ESCALA (ID)</InputLabel>
            <Select value={selectedEscalaFunc} label="ESCALA (ID)" onChange={e => setSelectedEscalaFunc(e.target.value)}>
              <MenuItem value=""><em>Selecione...</em></MenuItem>
              {escalas.filter(e => !selectedJornadaFiltro || Number(e.jornada) === Number(selectedJornadaFiltro)).map(e => (
                <MenuItem key={e.id} value={e.id}>ID: {e.id}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>

        <Box sx={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
          <TableContainer component={Paper} sx={{ maxWidth: 450 }}>
            <Table size="small">
              <TableHead sx={{ bgcolor: '#f5f5f5' }}><TableRow><TableCell>Dia</TableCell><TableCell>Entrada</TableCell><TableCell>Saída</TableCell></TableRow></TableHead>
              <TableBody>
                {daysOfWeek.map(d => {
                  const preview = escalas.find(e => Number(e.id) === Number(selectedEscalaFunc));
                  return (
                    <TableRow key={d.label}>
                      <TableCell>{d.label}</TableCell>
                      <TableCell><TextField size="small" variant="standard" value={preview?.[d.entrada] || '--:--'} disabled /></TableCell>
                      <TableCell><TextField size="small" variant="standard" value={preview?.[d.saida] || '--:--'} disabled /></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack spacing={3} sx={{ minWidth: 250 }}>
            <TextField label="Vigência" type="date" value={dataInicio} onChange={e => handleDataInicioChange(e.target.value)} InputLabelProps={{ shrink: true }} />
            {dataEscalaAntigaExibicao && (
              <Typography variant="caption" color="text.secondary">
                Escala atual desde: {dataEscalaAntigaExibicao}
              </Typography>
            )}
            <Button variant="contained" color="primary" size="large" onClick={handlePreSave} disabled={loading}>
              Salvar e Popular Ponto
            </Button>
          </Stack>
        </Box>
      </TabPanel>

      <Dialog open={openConfirmDataAntiga} onClose={() => setOpenConfirmDataAntiga(false)}>
        <DialogTitle>Data bem anterior</DialogTitle>
        <DialogContent>
          <Typography>
            Essa data é anterior a {mesLimiteExibicao}. Tem certeza que é essa mesmo?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => {
              setOpenConfirmDataAntiga(false);
              setDataInicio(new Date().toISOString().split('T')[0]);
            }}
          >
            Não, voltar para hoje
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenConfirmDataAntiga(false);
              setDataInicio(dataPendente);
            }}
          >
            Sim, é essa mesmo
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG DE CONFIRMAÇÃO RESTAURADO */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirmação de Alteração</DialogTitle>
        <DialogContent><Typography sx={{ whiteSpace: 'pre-line' }}>{msgConfirm}</Typography></DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpenConfirm(false)}>Cancelar</Button>
          <Button onClick={() => executeSave(false)} variant="outlined">Salvar (Manter Dia -1)</Button>
          <Button onClick={() => executeSave(true)} variant="contained" color="error">Salvar (Excluir Dia -1)</Button>
        </DialogActions>
      </Dialog>

      {/* ABA 1: NOVA */}
      <TabPanel value={tabIndex} index={1}>
        <FormControl sx={{ minWidth: 300, mb: 3 }}>
          <InputLabel>Jornada</InputLabel>
          <Select value={selectedJornadaNew} label="Jornada" onChange={e => setSelectedJornadaNew(e.target.value)}>
            {jornadas.map(j => <MenuItem key={j.id} value={j.id}>{j.nome}</MenuItem>)}
          </Select>
        </FormControl>
        {selectedJornadaNew && (
            <Box>
                <FormControlLabel control={<Checkbox checked={allEqualNew} onChange={e => setAllEqualNew(e.target.checked)}/>} label="Repetir horários da segunda" />
                <TableContainer component={Paper} sx={{ maxWidth: 450, my: 2 }}>
                    <Table size="small">
                        <TableBody>
                            {daysOfWeek.map(d => (
                                <TableRow key={d.label}>
                                    <TableCell>{d.label}</TableCell>
                                    <TableCell><TextField type="time" size="small" value={newEscalaData[d.entrada] || ''} onChange={e => handleNewCellChange(d.label, d.entrada, e.target.value)}/></TableCell>
                                    <TableCell><TextField type="time" size="small" value={newEscalaData[d.saida] || ''} onChange={e => handleNewCellChange(d.label, d.saida, e.target.value)}/></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Button variant="contained" onClick={handleSaveNewEscala}>Gravar Escala</Button>
            </Box>
        )}
      </TabPanel>

      {/* ABA 2: EDITAR */}
      <TabPanel value={tabIndex} index={2}>
        <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
            <FormControl sx={{ minWidth: 250 }}>
                <InputLabel>Jornada</InputLabel>
                <Select value={selectedJornadaEdit} label="Jornada" onChange={e => { setSelectedJornadaEdit(e.target.value); setSelectedEscalaEdit(''); }}>
                    {jornadas.map(j => <MenuItem key={j.id} value={j.id}>{j.nome}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl sx={{ minWidth: 200 }}>
                <InputLabel>Escala (ID)</InputLabel>
                <Select value={selectedEscalaEdit} label="Escala (ID)" onChange={e => setSelectedEscalaEdit(e.target.value)}>
                    {escalas.filter(e => Number(e.jornada) === Number(selectedJornadaEdit)).map(e => <MenuItem key={e.id} value={e.id}>ID: {e.id}</MenuItem>)}
                </Select>
            </FormControl>
        </Stack>
        {editEscalaData && (
            <Box>
                <FormControlLabel control={<Checkbox checked={allEqualEdit} onChange={e => setAllEqualEdit(e.target.checked)}/>} label="Copiar horários da segunda" />
                <TableContainer component={Paper} sx={{ maxWidth: 450, my: 2 }}>
                    <Table size="small">
                        <TableBody>
                            {daysOfWeek.map(d => (
                                <TableRow key={d.label}>
                                    <TableCell>{d.label}</TableCell>
                                    <TableCell><TextField type="time" size="small" value={editEscalaData[d.entrada] || ''} onChange={e => handleEditCellChange(d.label, d.entrada, e.target.value)}/></TableCell>
                                    <TableCell><TextField type="time" size="small" value={editEscalaData[d.saida] || ''} onChange={e => handleEditCellChange(d.label, d.saida, e.target.value)}/></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Button variant="contained" color="secondary" onClick={handleUpdateEscala}>Atualizar Escala</Button>
            </Box>
        )}
      </TabPanel>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity} variant="filled">{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}

export default PontoEscala;